import * as actions from "./actionTypes";

export const uploadRosteringFile = (payload) => ({
  type: actions.UPLOAD_ROSTER_DATA,
  payload: payload,
});

export const uploadRosteringFileSuccess = (payload) => ({
  type: actions.UPLOAD_ROSTER_DATA_SUCCESS,
  payload: payload,
});

export const validateRosteringFile = (payload) => ({
  type: actions.VALIDATE_ROSTER_DATA,
  payload: payload,
});

export const validateRosteringFileSuccess = (payload) => ({
  type: actions.VALIDATE_ROSTER_DATA_SUCCESS,
  payload: payload,
});

export const fetchTeacherRosterDetails = (payload) => ({
  type: actions.GET_TEACHER_ROSTER_DETAILS,
  payload: payload,
});

export const fetchTeacherRosterDetailsSuccess = (payload) => ({
  type: actions.GET_TEACHER_ROSTER_DETAILS_SUCCESS,
  payload: payload,
});

export const deleteRosteredStudent = (payload) => ({
  type: actions.DELETE_ROSTERED_STUDENT,
  payload: payload,
});

export const deleteRosteredStudentSuccess = (payload) => ({
  type: actions.DELETE_ROSTERED_STUDENT_SUCCESS,
  payload: payload,
});
